import React from "react";
import ModalFooterButtons from "./ModalFooterButtons";
const ModalFooter = props => (
  <div className="clearfix">
    <ModalFooterButtons {...props} />
  </div>
);
export default ModalFooter;
